import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';
import serverVars from 'server-vars';

import {
    showSuspectedTradeUserAcquisition,
    TRADE_WINDFALL_REFERRAL_KEY,
    showSuspectedTradeTest,
    trackSuspectedTradeTest,
} from './helpers';

const SuspectedTradeUser = React.lazy(() =>
    import(/* webpackChunkName: "SuspectedTradeUser" */ './SuspectedTradeUser')
);

function SuspectedTradeUserLazyComponent({ viewer, userId, relay }) {
    const [continueShowing, setContinueShowing] = useState(false);
    const tradeStatus = get(viewer, 'user.verifiedTradeStatus');
    //only have the windfall flag supersede trade status if user has none
    const hasWindfallFlag = localStorage.getItem(TRADE_WINDFALL_REFERRAL_KEY) && !tradeStatus;
    const isQualifiedForSuspectedTradeTest = !userId;
    const isSuspectedTradeTestVariant =
        isQualifiedForSuspectedTradeTest && showSuspectedTradeTest();

    useEffect(() => {
        if (isQualifiedForSuspectedTradeTest) {
            const pageType = serverVars.get('settings.pageType');
            trackSuspectedTradeTest(pageType);
        }
    }, [isQualifiedForSuspectedTradeTest]);

    const shouldShowSuspectedTrade =
        showSuspectedTradeUserAcquisition() &&
        ((tradeStatus === 'SUSPECTED' && !get(viewer, 'user.isVip')) ||
            continueShowing ||
            hasWindfallFlag ||
            isSuspectedTradeTestVariant);

    //if the suspected trade placement is shown this session, keep showing it regardless of prop changes
    if (shouldShowSuspectedTrade && !continueShowing) {
        setContinueShowing(true);
    }

    if (!shouldShowSuspectedTrade) {
        return null;
    }

    return (
        <React.Suspense fallback="">
            <SuspectedTradeUser
                viewer={viewer}
                userId={userId}
                relay={relay}
                onDismissAqcuisition={() => setContinueShowing(true)}
            />
        </React.Suspense>
    );
}

SuspectedTradeUserLazyComponent.propTypes = {
    viewer: PropTypes.object,
    userId: PropTypes.string,
    relay: PropTypes.object,
};

export const SuspectedTradeUserLazy = createFragmentContainer(SuspectedTradeUserLazyComponent, {
    viewer: graphql`
        fragment SuspectedTradeUserLazy_viewer on Viewer {
            contactInfo {
                phoneNumbers {
                    tradeSupport(formatType: INTERNATIONAL)
                }
            }
            user(userId: $userId) @include(if: $hasUserId) {
                verifiedTradeStatus
                isVip
            }
        }
    `,
});
